export default __webpack_public_path__ + "static/media/hospital.9725937f.svg";